<ra-modal
    [title]="('document.edit.imageColumns.title' | translate)"
    [size]="'small'"
    (close)="close.emit()">

    <p class="subtitle">
        {{ 'document.edit.imageColumns.subtitle' | translate:{ count: imagesCount() } }}
    </p>

    <div class="options-card">
        @for (option of options(); track option.columns) {
            <button
                type="button"
                class="option-row"
                (click)="columnsSelected.emit(option.columns)">

                <!-- Prévia do grid: o mesmo número de colunas que a opção cria -->
                <span class="grid-preview" [style.--columns]="option.columns">
                    @for (cell of option.cells; track cell) {
                        <span class="grid-cell"></span>
                    }
                </span>

                <span class="option-text">
                    <span class="option-title">{{ option.titleKey | translate }}</span>
                    <span class="option-description">{{ option.descriptionKey | translate }}</span>
                </span>
            </button>
        }
    </div>
</ra-modal>
